import { GameSettingType } from "@1games-ru/region-shared/dist/enums/account/settings";
import useAppSelector from "@/core/helpers/useAppSelector";
import { isShowSelector, useHudStore } from "@/domains/hud/store";
import useSetHud from "@/domains/hud/hooks/useSetHud.ts";
import useShowHud from "@/domains/hud/hooks/useShowHud";
import HudEffectsContainer from "@/domains/hud/containers/HudEffectsContainer";
import HudHintsContainer from "@/domains/hud/containers/HudHintsContainer";
import HudLocationContainer from "@/domains/hud/containers/HudLocationContainer";
import HudMapContainer from "@/domains/hud/containers/HudMapContainer";
import HudMoneyContainer from "@/domains/hud/containers/HudMoneyContainer";
import HudPingContainer from "@/domains/hud/containers/HudPingContainer";
import HudServerInfoContainer from "@/domains/hud/containers/HudServerInfoContainer";
import HudSpeakerListContainer from "@/domains/hud/containers/HudSpeakerListContainer";
import HudSpeakingIndicatorConainter from "@/domains/hud/containers/HudSpeakingIndicatorContainer";
import HudSpeedometerContainer from "@/domains/hud/containers/HudSpeedometerContainer";
import HudWantadLevelContainer from "@/domains/hud/containers/HudWantadLevelContainer";
import HudWeaponContainer from "@/domains/hud/containers/HudWeaponContainer";
import NotificationsBottomContainer from "@/domains/notifications/containers/NotificationsBottomContainer";
import NotificationsContainer from "@/domains/notifications/containers/NotificationsContainer";
import { appliedBasicSettingsSelector } from "@/domains/settings/basic/slice";

export default function HudContainer() {
  useShowHud();
  const appliedBasicSettings = useAppSelector(appliedBasicSettingsSelector);
  useSetHud();
  const isShow = useHudStore(isShowSelector);

  if (!appliedBasicSettings) return null;
  if (!appliedBasicSettings[GameSettingType.SettingShowHUD]) return null;

  if (!isShow) {
    return (
      <>
        <div className="absolute bottom-[--boundary-offset-y] left-[--boundary-offset-x] flex flex-col justify-end items-start pointer-events-none">
          <NotificationsContainer />
        </div>

        <div className="absolute left-1/2 -translate-x-1/2 bottom-0 pointer-events-none">
          <NotificationsBottomContainer />
        </div>
      </>
    );
  }

  return (
    <>
      <div className="absolute inset-y-[--boundary-offset-y] left-[--boundary-offset-x] flex flex-col justify-end items-start pointer-events-none">
        <div className="flex items-end gap-2.5">
          <div className="flex flex-col gap-1.5 w-[--map-w]">
            <HudSpeakerListContainer />
            <NotificationsContainer />
            <HudLocationContainer />
            {appliedBasicSettings[GameSettingType.SettingShowMap] && <HudMapContainer />}
          </div>
          <div className="flex flex-col gap-2.5">
            <div className="flex items-center gap-1.5">
              <HudEffectsContainer />
              <HudSpeakingIndicatorConainter />
            </div>
            <HudMoneyContainer />
          </div>
        </div>
      </div>

      <div className="absolute left-1/2 -translate-x-1/2 bottom-0 pointer-events-none">
        <NotificationsBottomContainer />
        <HudWeaponContainer />
      </div>

      <div className="w-fit absolute inset-y-[--boundary-offset-y] right-[--boundary-offset-x] flex flex-col justify-between gap-5 overflow-clip pointer-events-none">
        <div className="flex flex-col items-end gap-5">
          <HudServerInfoContainer />
          <HudPingContainer />
          <HudWantadLevelContainer />
        </div>
        <div className="flex flex-col items-end gap-5 mt-auto">
          {appliedBasicSettings[GameSettingType.SettingShowHotkeys] && <HudHintsContainer />}
          <HudSpeedometerContainer />
        </div>
      </div>
    </>
  );
}
